module.exports = __webpack_public_path__ + "static/media/carla_italian.057b01cb.mp3";